// https://davidwalsh.name/detect-scrollbar-width
export default class MeasureScrollBar {
  constructor() {
    this.width = null;
  }

  getWidth() {
    if (this.width !== null) return this.width;

    // Create measurement node
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999em';
    scrollDiv.style.left = '-9999em';
    document.body.appendChild(scrollDiv);

    // Get width
    this.width = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Delete the div
    document.body.removeChild(scrollDiv);

    return this.width;
  }
}
